import { useQuery } from "@apollo/client";

import ExpertSessions from "@components/expertSection/ExpertSessions";
import HandleQuery from "@components/HandleQuery";
import ExpertJourneyPage from "@components/pageTypes/ExpertJourneyPage";
import {
  GetJourneyWithExpertAndConsultsDocument,
  GetJourneyWithExpertAndConsultsQuery,
  GetJourneyWithExpertAndConsultsQueryVariables
} from "@typing/Generated";

type Props = {
  journeyId: string;
};

const ExpertJourneyExpertPage = ({ journeyId }: Props) => {
  const getJourneyQuery = useQuery<GetJourneyWithExpertAndConsultsQuery, GetJourneyWithExpertAndConsultsQueryVariables>(
    GetJourneyWithExpertAndConsultsDocument,
    {
      variables: { id: journeyId }
    }
  );

  return (
    <ExpertJourneyPage helmetKey="pageTitles.client.expert.show" journeyId={journeyId}>
      <HandleQuery query={getJourneyQuery}>
        {journeyData => <ExpertSessions journey={journeyData.journey} />}
      </HandleQuery>
    </ExpertJourneyPage>
  );
};

export default ExpertJourneyExpertPage;
